import { getCurrentUserId } from '@helpers/firebase/Auth';
import db, { convertFirestoreData, setDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Contact, DeviceContact } from '@types';

function parseContactDoc(doc: db.DocumentSnapshot) {
  return convertFirestoreData(doc.data()) as Contact;
}

function getContactDocRef(contactId: string) {
  return db.doc(firestore, 'contacts', getContactDocId(contactId));
}

export function getContactDocId(contactId: string) {
  return getCurrentUserId() + contactId;
}

export async function addContact(contact: DeviceContact) {
  return await setDocWithTimestamps(getContactDocRef(contact.contactId), contact);
}

export async function addContacts(contacts: DeviceContact[]) {
  return await Promise.all(contacts.map((contact) => addContact(contact)));
}

export async function getContact(contactId: string) {
  const snap = await db.getDoc(getContactDocRef(contactId));
  return parseContactDoc(snap);
}
